import { useTranslation } from 'react-i18next';

const CTASection = () => {
  const { t } = useTranslation();

  return (
    <section className="py-24 bg-gradient-to-r from-[#0A1628] to-[#1A1A1A] relative overflow-hidden">
      <div className="absolute top-0 left-0 w-72 h-72 opacity-5">
        <div className="grid grid-cols-8 gap-4">
          {Array.from({ length: 64 }).map((_, i) => (
            <div key={i} className="w-2 h-2 bg-white rounded-full"></div>
          ))}
        </div>
      </div>
      <div className="absolute bottom-0 right-0 w-72 h-72 opacity-5">
        <div className="grid grid-cols-8 gap-4">
          {Array.from({ length: 64 }).map((_, i) => (
            <div key={i} className="w-2 h-2 bg-white rounded-full"></div>
          ))}
        </div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 md:px-8 text-center">
        <span className="text-[#FF6B35] text-sm font-semibold uppercase tracking-widest">{t('cta.tag')}</span>
        <h2 className="text-4xl md:text-6xl font-extrabold text-white mt-4 mb-6 leading-tight">
          {t('cta.title')}
        </h2>
        <p className="text-white/60 text-lg md:text-xl mb-10 max-w-2xl mx-auto leading-relaxed">
          {t('cta.subtitle')}
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href="https://wa.me/17542034748"
            target="_blank"
            rel="nofollow noreferrer"
            className="inline-flex items-center justify-center gap-2 bg-[#FF6B35] text-white font-bold px-10 py-5 rounded-full whitespace-nowrap cursor-pointer hover:bg-[#e85a24] transition-all duration-200 text-lg"
          >
            {t('cta.btn1')}
            <i className="ri-arrow-right-line text-xl"></i>
          </a>
          <a
            href="https://wa.me/17542034748"
            target="_blank"
            rel="nofollow noreferrer"
            className="inline-flex items-center justify-center gap-2 bg-[#25D366] text-white font-bold px-10 py-5 rounded-full whitespace-nowrap cursor-pointer hover:bg-[#1ebe5a] transition-all duration-200 text-lg"
          >
            <i className="ri-whatsapp-line text-xl"></i>
            {t('cta.btn2')}
          </a>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
